// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__2v--y","inOutData":"styles_inOutData__1u6te","round":"styles_round__3n4ih"};